import { Authenticated } from "@refinedev/core";
import Subscription from "./components/Subscription";
import { Breadcrumbs } from "components/Breadcrumbs";

const SubscriptionPage = () => {
  return (
    <Authenticated key="subscription">
      <Breadcrumbs />
      <Subscription />
    </Authenticated>
  );
};

export default SubscriptionPage;
